import type React from 'react'

import type { ValueType } from 'components/uiKit/KitTypes'

export type CourseKitIndents = Pick<
  React.CSSProperties,
  | 'margin'
  | 'marginLeft'
  | 'marginTop'
  | 'marginRight'
  | 'marginBottom'
  | 'padding'
  | 'paddingLeft'
  | 'paddingTop'
  | 'paddingRight'
  | 'paddingBottom'
>

export enum CourseKitSize {
  XS = 'xmini',
  S = 'mini',
  M = 'medium',
  L = 'large',
}

export type CourseValueType = ValueType

export interface ICourseLabelProps {
  disabled?: boolean
  error?: boolean
}

export interface ICourseOption<V, LP extends ICourseLabelProps = ICourseLabelProps> {
  id: string | number
  value: V
  label?: React.ReactNode | React.FC<LP>
  textLabel?: string
  icon?: React.ReactNode
  disabled?: boolean
  hidden?: boolean
}
